import React, { 
  useState, 
  useCallback, 
  useEffect,
} from "react";

import { 
  AsyncSelect as AsyncReactSelect 
} from "chakra-react-select";

type SelectProps = {
  id?: string;
  isMultiple?: true;
  placeholder?: string;
  options: (inputValue: string) => Promise<Array<Record<string, any>>>;
  onChange: (event: any) => void;
  onBlur?: () => void;
  inputRef?: React.MutableRefObject<any>;

  canSelectAll?: true;
  selectAllLabel?: string;
  allOptions?: (inputValue: string) => Promise<Array<object>>;
  defaultValues?: Array<any>;
};

const AsyncSelect: React.FC<SelectProps> = ({
  id,
  placeholder,
  options,
  isMultiple,
  inputRef,
  onChange,
  allOptions,
  canSelectAll,
  selectAllLabel,
  onBlur,
  defaultValues
}) => {
  const [selectedValues, setSelectedValues] = useState(null);

  const handleChangeSelect = useCallback(async (values) => {
    if (
      isMultiple != null &&
      canSelectAll != null &&
      values.filter(({value}) => value === "all") &&
      values.length > 0
    ) {

      if (
        (values[0].value === "all" && values.length == 1) ||
        (values[values.length - 1].value === "all")
      ) {
        const data = await allOptions("");
        onChange(data);
        setSelectedValues({
          label: selectAllLabel,
          value: "all",
        });
      } else {
        const valuesExceptSelectAllOption = values.filter(({value}) => value !== "all");
        onChange(valuesExceptSelectAllOption);
        setSelectedValues(valuesExceptSelectAllOption);
      }
      
    } else {
      onChange(values);
      setSelectedValues(values);
    }
  }, [ isMultiple, canSelectAll, onChange, allOptions, setSelectedValues ]);

  const handleOptions = useCallback(async (inputValue: string) => {
    const optionsValues = await options(inputValue);

    if (isMultiple != null && canSelectAll != null) {
      return [
        {
          label: selectAllLabel,
          value: "all",
        },
        ...optionsValues,
      ];
    }

    return optionsValues;
  }, [ isMultiple, canSelectAll, selectAllLabel ]);

  useEffect(() => {
    if(defaultValues) {
      allOptions("").then((users) => {
        setSelectedValues(users.filter((user) => defaultValues.includes(user.value)));
      });  
    }
  }, 
  [defaultValues]);

  return (
    <AsyncReactSelect
      id={id}
      inputRef={inputRef}
      cacheOptions
      hideSelectedOptions={false}
      isMulti={isMultiple}
      placeholder={placeholder}
      defaultOptions
      loadOptions={handleOptions}
      closeMenuOnSelect={!isMultiple}
      selectedOptionStyle="check"
      onChange={handleChangeSelect}
      onBlur={onBlur}
      value={selectedValues}
    />
  );
};

export default React.memo(AsyncSelect);
